import { Component, Input, SimpleChanges } from '@angular/core';
import { Calendar, CalendarOptions } from 'fullcalendar';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import esLocale from '@fullcalendar/core/locales/es';
import zhTwLocale from '@fullcalendar/core/locales/zh-tw';
import { finalize, firstValueFrom, Observable, of } from 'rxjs';
import { AgendaService } from 'src/app/pages/calendar/services/agenda.service';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { CenterInfo } from 'src/app/core/interfaces/my-workshop';
import { Agenda, AgendaListResponse, AgendaStatus } from 'src/app/models/agenda.model';
import { AgendaStatusColorsService } from 'src/app/pages/calendar/services/agenda-status-colors.service';
import { DateFormatLocalizationService } from 'src/app/core/services/date-format-localization.service';

// interface CalendarEventAgenda {
//   serviceName: string;
//   vehicleInfo: string;
//   employeeName?: string;
//   status: 'pending' | 'confirmed' | 'canceled' | 'completed';
// }

interface CalendarEvent {
  id: number | string;
  title: string;
  start: Date | string | number;
  end: Date | string | number;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  allDay: boolean;
  classNames: string[],
  extendedProps?: {
    agenda?: Agenda;
  };
}


@Component({
  selector: 'app-calendar-day-view',
  templateUrl: './calendar-day-view.component.html',
  styleUrls: ['./calendar-day-view.component.scss']
})
export class CalendarDayViewComponent {

  calendarApi!: any;
  currentLang = 'es';
  events: any[] = [];          // ← cargarás tus citas aquí
  isGroupAdmin = false;        // ← tu lógica
  showEmployeeView = false;

  @Input()
  currentDate: Date | null = new Date();

  @Input()
  heightCalendar: string = "300px";

  centerData: CenterInfo | undefined;
  calendarOptions: CalendarOptions | null = null



  constructor(private readonly agendaService: AgendaService, private readonly myAccountService: MyAccountService, private readonly agendaStatusColorsService: AgendaStatusColorsService,
    private readonly dateFormatLocalization: DateFormatLocalizationService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.centerData = await this.myAccountService.loadCenter() ?? undefined;

    // cargar eventos desde tu API o servicio

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentDate'] && changes['currentDate'].previousValue != changes['currentDate'].currentValue) {
      console.log("currentDate: ", this.currentDate)
      // this.loadEvents()
      this.setCalendarOptions()

      setTimeout(() => {
        this.loadEvents();
      }, 100);
    }
  }

  async loadEvents() {
    try {
      if (typeof this.currentDate === 'string') {
        // const [y, m, d] = this.currentDate.split('-').map(Number);
        // this.currentDate = new Date(y, m - 1, d);
        this.currentDate = new Date(this.currentDate)
      }
      console.log("currentDate (local): ", this.currentDate);

      const response = await firstValueFrom(this.getEvents());
      this.events = this.mapEvents(response.agendas); // Ejemplo
      this.updateCalendarEvents();

    } catch (err) {
      console.error('Error loading agendas', err);
    }

  }

  updateCalendarEvents() {
    if (!this.calendarApi) return;
    this.calendarApi.removeAllEvents();
    this.calendarApi.addEventSource(this.events);
    this.calendarApi.gotoDate(this.currentDate);
  }

  handleDateClick(info: any) {
    console.log('click en fecha', info);
  }

  handleEventClick(info: any) {
    console.log('click en evento', info.event);
  }
  getUTCStart(startDate: Date): Date {
    console.log("currentDate: ", this.currentDate)
    return new Date(Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      0, 0, 0, 0));
  }

  getUTCEnd(startDate: Date): Date {
    console.log("currentDate: ", this.currentDate)
    return new Date(Date.UTC(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(), 23, 59, 59, 999));
  }

  // getDayStart(date: Date): Date {
  //   return new Date(
  //     date.getFullYear(),
  //     date.getMonth(),
  //     date.getDate(),
  //     0, 0, 0, 0
  //   );
  // }

  // getDayEnd(date: Date): Date {
  //   return new Date(
  //     date.getFullYear(),
  //     date.getMonth(),
  //     date.getDate(),
  //     23, 59, 59, 999
  //   );
  // }

  getEvents(): Observable<AgendaListResponse> {
    if (!this.currentDate) { return of() }
    const date = new Date(this.currentDate);

    return this.agendaService.getAll(
      this.centerData?.id,
      null,
      this.getUTCStart(date),
      this.getUTCEnd(date)
    ).pipe(
      finalize(() => { })
    );
  }

  mapEvents(agendas: Agenda[]) {
    return agendas.map((x: Agenda) => {
      return this.mapEvent(x)
    })
  }

  mapEvent(agenda: Agenda): CalendarEvent {
    const endDate = this.calculateSingleDayEndTime(agenda, new Date(agenda.agendaDateTimeUtc));

    const { serviceClass, statusClass, colors } = this.getEventStyles(agenda);
    return {
      id: agenda.id.toString(),
      title: "",
      start: new Date(agenda.agendaDateTimeUtc),
      end: endDate,
      allDay: false,
      backgroundColor: colors.bg,
      borderColor: colors.border,
      textColor: colors.text,
      classNames: [serviceClass, statusClass].filter(Boolean),
      extendedProps: {
        agenda: {
          ...agenda,
        }
      }
    };
  }

  private getEventStyles(agenda: Agenda): { serviceClass: string, statusClass: string, colors: any; } {
    const statusKey = agenda.status !== undefined && AgendaStatus[agenda.status] ? agenda.status : AgendaStatus.PENDING;
    const colors = this.agendaStatusColorsService.getStatusColors(statusKey);

    let serviceClass = '';
    if (agenda.serviceName) {
      const serviceNameLower = agenda.serviceName.toLowerCase();
      if (serviceNameLower.includes('aceite')) serviceClass = 'service-oil-change';
      else if (serviceNameLower.includes('manteni')) serviceClass = 'service-maintenance';
      else if (serviceNameLower.includes('neumático') || serviceNameLower.includes('neumatico')) serviceClass = 'service-tires';
    }

    const statusClass = `agenda-status-${AgendaStatus[statusKey]?.toLowerCase()}`;

    return { serviceClass, statusClass, colors };
  }

  private calculateSingleDayEndTime(agenda: Agenda, startDate: Date): Date {
    const endDate = new Date(startDate.getTime());
    const durationStr = agenda.duration || agenda.serviceDuration;

    if (durationStr) {
      const [hours, minutes, seconds] = durationStr.split(':').map(Number);
      endDate.setHours(startDate.getHours() + (hours || 0));
      endDate.setMinutes(startDate.getMinutes() + (minutes || 0));
      endDate.setSeconds(startDate.getSeconds() + (seconds || 0));
    } else {
      endDate.setHours(startDate.getHours() + 1);
    }

    return endDate;
  }


  setCalendarOptions() {
    if (!this.currentDate) { return }

    this.calendarOptions = {
      initialDate: new Date(this.currentDate),
      timeZone: 'local',
      plugins: [
        interactionPlugin,
        dayGridPlugin,
        timeGridPlugin,
        listPlugin
      ],
      initialView: 'timeGridDay',
      locale: esLocale,
      locales: [esLocale, zhTwLocale],

      headerToolbar: {
        left: '', //prev,next
        center: '',
        right: ''
      },

      buttonIcons: {
        prev: 'chevron-left',
        next: 'chevron-right'
      },

      titleFormat: {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      },

      dayHeaderFormat: {
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        omitCommas: true
      },

      dayHeaderContent: (args) => {
        let weekday = args.date.toLocaleDateString(this.dateFormatLocalization.getCurrentConfig().locale, { weekday: 'short' }).toLowerCase();
        let date = args.date.getDate();

        return {
          html: `
      <div class="custom-header">
        <div class="weekday">${weekday}</div>
        <div class="date">${date}</div>
      </div>
    `
        };
      },
      eventContent: (arg) => {
        const customEl = document.createElement('div');
        customEl.className = 'custom-event-wrapper';

        const serviceName = arg.event.extendedProps?.['agenda']?.['serviceName'] || '';
        const vehicleInfo = arg.event.extendedProps?.['agenda']?.['vehicleInfo'] || '';
        const employeeName = arg.event.extendedProps?.['agenda']?.['employeeName'] || '';
        const clientName = arg.event.title || 'No Client';
        const status = arg.event.extendedProps?.['agenda']?.['status'] || 'pending';

        let statusText = '';
        switch (status) {
          case 'pending': statusText = 'Pendiente'; break;
          case 'confirmed': statusText = 'Confirmado'; break;
          case 'canceled': statusText = 'Cancelado'; break;
          case 'completed': statusText = 'Completado'; break;
        }

        const timeText = arg.timeText || '';

        customEl.innerHTML = `
        <div class="event-header">
            <div class="service-name">${serviceName}</div>
            <div class="event-time">${timeText}</div>
        </div>
       
      `;

        // <div class="event-vehicle-info">${vehicleInfo}</div>
        // <div class="event-client-employee">
        //     <div class="client-name">${clientName}</div>
        //     ${employeeName ? `<div class="employee-name">${employeeName}</div>` : ''}
        // </div>
        // <div class="event-status">${statusText}</div>

        return { domNodes: [customEl] };
      },

      slotMinTime: '06:00:00',
      slotMaxTime: '20:00:00',
      slotDuration: '01:00:00',
      allDaySlot: false,

      initialEvents: [],
      editable: true,
      selectable: true,

      nowIndicator: true,


      dateClick: this.handleDateClick.bind(this),
      eventClick: this.handleEventClick.bind(this),

      eventDidMount: (info) => {
        if (!info.event.backgroundColor) {
          info.el.style.backgroundColor = '#6e7078';
          info.el.style.borderColor = '#5c5d63';
        }
      },

      datesSet: (dateInfo) => {
        if (!this.calendarApi && dateInfo.view.calendar) {
          this.calendarApi = dateInfo.view.calendar;

          this.calendarApi.gotoDate(this.currentDate);

          if (this.events.length > 0) {
            this.updateCalendarEvents();
          }
        }
      },

      viewDidMount: (viewInfo) => {
        this.calendarApi = viewInfo.view.calendar;
        this.calendarApi.setOption('editable', !this.isGroupAdmin);
      }
    };
  }



}